import i18next from "i18next";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { DocumentationLinksMap } from "components/NavBar/documentationLinks";

const getSupportLink = (pathname: string, currentLanguage: string) => {
  const supportPage = DocumentationLinksMap.get(pathname);
  if (!supportPage) return;

  return supportPage.get(currentLanguage) || supportPage.get("en");
};

export const SupportButton = () => {
  const location = useLocation();

  const supportLink = getSupportLink(location.pathname, i18next.language.split("-")[0]);

  if (!supportLink) return null;

  return (
    <Link className="button" to="#" onClick={() => window.open(supportLink, "_blank")}>
      <Icon className="question solid" />
    </Link>
  );
};
